import type { Dictionnaire } from '../type';
import { compte as nombre } from './pluriel';

export const messages: Dictionnaire['messages'] = {
  amis: {
    croise: 'التقيتما في فعالية',
    soiMeme: 'لا يمكنك إضافة نفسك',
    compteOfficiel: 'لا يمكن إضافة حساب التطبيق صديقًا. يمكنك مراسلته.',
    bloque: 'لقد حظرت هذا العضو: ألغِ الحظر قبل إرسال طلب صداقة',
    refuse: 'هذا العضو لا يقبل طلبك الآن',
    plusDeDemande: 'هذا الطلب لم يعد موجودًا',
    nouveau: 'جديد في المدينة',
  },
  erreurs: {
    plusDeConversation: 'هذه المحادثة لم تعد موجودة',
    pasMembre: 'لست جزءًا من هذه المحادثة',
    demandeEnAttente: 'أُرسلت رسالتك. يمكنك المتابعة بعد أن يردّ هذا الشخص.',
    plusAmis: 'لم تعودا صديقين: هذه المحادثة مغلقة',
    injoignable: 'هذا العضو لا يستقبل رسائلك حاليًا',
    vide: 'اكتب رسالة قبل إرسالها',
    effacerLesSiens: 'يمكنك حذف رسائلك فقط',
    modifierLesSiens: 'يمكنك تعديل رسائلك فقط',
    tropTardPourModifier: 'لا يمكن تعديل الرسالة إلا خلال 15 دقيقة من إرسالها.',
    priveSansNom: 'المحادثة الخاصة ليس لها اسم',
    renommerAdmin: 'المشرف وحده يستطيع إعادة تسمية المجموعة',
    nomDuGroupe: 'أعطِ المجموعة اسمًا',
    priveSansDescription: 'المحادثة الخاصة ليس لها وصف',
    descriptionAdmin: 'المشرف وحده يستطيع تغيير الوصف',
    priveSansAdmin: 'المحادثة الخاصة ليس لها مشرف',
    passerAdmin: 'مشرف المجموعة وحده يستطيع التسليم',
    plusDansLeGroupe: 'هذا العضو لم يعد في المجموعة',
    priveSansMembres: 'المحادثة الخاصة ليس لها أعضاء',
    retirerAdmin: 'مشرف المجموعة وحده يستطيع إزالة عضو',
    utiliseQuitter: 'استخدم «مغادرة المجموعة»',
    priveSansPhoto: 'المحادثة الخاصة ليس لها صورة',
    photoAdmin: 'مشرف المجموعة وحده يستطيع تغيير صورتها',
    soiMeme: 'لا يمكنك محادثة نفسك',
    bloque: 'لقد حظرت هذا العضو. ألغِ الحظر من ملفه لمراسلته.',
    priveFermee: 'المحادثة الخاصة لا تقبل أعضاء آخرين',
    groupeDeSortie: 'تنضم إلى هذه المجموعة بالانضمام إلى الفعالية، لا بدعوة',
    groupeDAsso: 'تنضم إلى هذه المجموعة بالانضمام إلى الجمعية، لا بدعوة',
    amisSeulement: 'يمكنك إضافة أصدقائك فقط إلى مجموعة',
    priveNeSeQuittePas: 'لا يمكن مغادرة محادثة خاصة',
    successeur: 'اختر من يتولى المجموعة قبل المغادرة.',
  },
  apercu: {
    groupe: 'مجموعة',
    photo: 'صورة',
    vocal: 'رسالة صوتية',
    video: 'فيديو',
    sortie: 'فعالية مشاركة',
    post: 'منشور مشارك',
    nouveau: 'رسالة جديدة',
  },
  commun: {
    photo: 'صورة',
    vocal: 'رسالة صوتية',
    video: 'فيديو',
    sortie: 'فعالية مشاركة',
    post: 'منشور مشارك',
    message: 'رسالة',
    supprime: 'حُذفت الرسالة',
    ecrit: 'يكتب…',
    nouveauMessage: 'رسالة جديدة',
    quitterGroupe: 'مغادرة المجموعة',
    aucunMembre: 'لم يُعثر على أعضاء',
    verifie: 'تحقّق من تهجئة اسم المستخدم.',
    aucunAmi: 'لا أصدقاء بعد',
    chercheUnPseudo: 'ابحث عن اسم مستخدم لدعوة شخص ليس صديقك بعد.',
    rechercherPseudo: 'ابحث عن اسم مستخدم…',
    infosGroupe: 'معلومات المجموعة',
    membres: 'الأعضاء',
    toi: 'أنت',
    moi: 'أنا',
    retirerQuelquun: (nom: string) => `إزالة ${nom}`,
    laisserEtPartirQ: (nom: string) => `ترك المجموعة لـ ${nom} والمغادرة؟`,
  },
  conversation: {
    pasParti: 'تعذّر إرسال هذه الرسالة.',
    pasModifie: 'تعذّر تعديل هذه الرسالة.',
    microIndisponible: 'الميكروفون غير متاح',
    vocalImpossible: 'تعذّر إرسال الرسالة الصوتية',
    envoiImpossible: 'تعذّر الإرسال الآن.',
    copie: 'تم نسخ الرسالة.',
    plusCharge: 'هذه الرسالة لم تعد في الجزء المحمّل من المحادثة.',
    reactionEchec: 'لم يتم التفاعل. أعد المحاولة.',
    effacement: 'تُحذف الرسائل بعد أسبوع من قراءتها.',
    pasAmis: 'لستما صديقين: يمكنك إرسال رسالة واحدة فقط. ستُفتح المحادثة إذا ردّ هذا الشخص.',
    dernierMessage: 'الانتقال إلى آخر رسالة',
    plusAmis: 'لم تعودا صديقين: هذه المحادثة مغلقة. أرسل له طلب صداقة جديدًا من ملفه لاستئناف المحادثة.',
    voirCite: 'عرض الرسالة المقتبسة',
    annulerReponse: 'إلغاء الردّ على هذه الرسالة',
    annulerModif: 'إلغاء تعديل هذه الرسالة',
    modifierLeMessage: 'تعديل الرسالة',
    ecrire: 'اكتب رسالة…',
    annulerEnregistrement: 'إلغاء التسجيل',
    reprendre: 'استئناف التسجيل',
    galerie: 'اختيار من المعرض',
    enregistrerVocal: 'تسجيل رسالة صوتية',
    lacherAnnuler: 'اترك للإلغاء',
    lacherEnvoyer: 'اترك للإرسال',
    envoyerVocal: 'إرسال الرسالة الصوتية',
    envoyer: 'إرسال',
    actions: 'إجراءات الرسالة',
    autreEmoji: 'اختيار رمز تعبيري آخر',
    repondre: 'ردّ',
    copier: 'نسخ النص',
    modifier: 'تعديل',
    infos: 'معلومات',
    supprimerQ: 'حذف هذه الرسالة؟',
    supprimer: 'حذف',
    chercherEmoji: 'البحث عن رمز تعبيري',
    reactions: 'التفاعلات',
    retraitEchec: 'لم تتمّ الإزالة. أعد المحاولة.',
    appuyerSupprimer: 'اضغط للإزالة.',
    infosMessage: 'معلومات الرسالة',
    vu: 'شوهدت',
    pasEncore: 'ليس بعد',
    distribue: 'وصلت',
    ceMembre: 'هذا العضو',
    photoEnvoyee: 'صورة أُرسلت في المحادثة',
    voirReactions: 'من تفاعل',
    postIndisponible: 'هذا المنشور لم يعد متاحًا.',
    voirProfil: (nom: string) => `عرض ملف ${nom}`,
    plusieursEcrivent: (n: number) => `${n} أشخاص يكتبون…`,
    appelerVideo: (nom: string) => `مكالمة فيديو مع ${nom}`,
    appeler: (nom: string) => `الاتصال بـ ${nom}`,
    nouveaux: (n: number) => nombre(n, 'رسالة جديدة', 'رسالتان جديدتان', 'رسائل جديدة', 'رسالة جديدة'),
    retirerReaction: (emoji: string) => `إزالة ${emoji}`,
    reagirAvec: (emoji: string) => `التفاعل بـ ${emoji}`,
    aucunEmoji: (quete: string) => `لا يوجد رمز تعبيري لـ «${quete}».`,
    systeme: {
      retire: (nom: string) => `أُزيل ${nom} من المجموعة.`,
      rejoint: (nom: string) => `انضم ${nom} إلى المجموعة.`,
      quitte: (nom: string) => `غادر ${nom} المجموعة.`,
      tuAsQuitte: 'غادرت المجموعة.',
      plusAmi: (nom: string) => `لم تعد صديقًا لـ ${nom}. ستُستأنف المحادثة عندما تعودان صديقين.`,
    },
    appel: {
      manque: (video: boolean) => `${video ? 'مكالمة فيديو فائتة' : 'مكالمة فائتة'}`,
      duree: (video: boolean, duree: string) => `${video ? 'مكالمة فيديو' : 'مكالمة'} · ${duree}`,
    },
    lu: 'قُرئت',
    modifie: 'معدّلة',
  },
  ajouterAmis: {
    titre: 'إضافة أصدقاء',
    boutons: {
      none: 'إضافة',
      requested: 'تم الطلب',
      incoming: 'قبول',
      friends: 'أصدقاء',
    },
    demandesRecues: (n: number) => `الطلبات الواردة · ${n}`,
    suggestions: (lieu: string | null) => `اقتراحات${lieu ? ` في ${lieu}` : ''}`,
    tousLesMembres: (n: number) => `جميع الأعضاء · ${n}`,
    accepter: (nom: string) => `قبول ${nom}`,
    refuser: (nom: string) => `رفض ${nom}`,
  },
  ajouterMembres: {
    impossible: 'تعذّرت الإضافة الآن.',
    titre: 'إضافة أعضاء',
    choisis: 'اختر من تضيف',
    resultats: 'النتائج',
    tesAmis: 'أصدقاؤك',
    dejaMembre: 'عضو بالفعل',
    ajouter: (n: number) => `إضافة ${nombre(n, 'عضو واحد', 'عضوين', 'أعضاء', 'عضوًا')}`,
  },
  groupe: {
    descriptionImpossible: 'تعذّر حفظ الوصف',
    renommageImpossible: 'تعذّرت إعادة التسمية',
    passerImpossible: 'تعذّر التسليم',
    retirerImpossible: 'تعذّرت إزالة هذا العضو',
    photoImpossible: 'تعذّر حفظ الصورة',
    quitterImpossible: 'تعذّرت مغادرة المجموعة',
    quitterQ: 'مغادرة المجموعة؟',
    nommerAdmin: 'تعيينه مشرفًا',
    retirer: 'إزالة من المجموعة',
    changerPhoto: 'تغيير صورة المجموعة',
    voirPhoto: 'عرض صورة المجموعة بملء الشاشة',
    modifierNom: 'تعديل اسم المجموعة',
    ajouterMembre: 'إضافة عضو',
    modifierDescription: 'تعديل وصف المجموعة',
    ajouterDescription: 'إضافة وصف',
    deQuoi: 'عمّ تتحدث هذه المجموعة؟',
    admin: 'مشرف',
    retirerQ: (nom: string) => `إزالة ${nom} من المجموعة؟`,
    meta: (n: number, date: string) => `${nombre(n, 'عضو واحد', 'عضوان', 'أعضاء', 'عضوًا')} · أُنشئت في ${date}`,
  },
  passation: {
    orphelin: 'لمن تعهد بالمجموعة؟',
    laisser: 'لمن تترك المجموعة؟',
  },
  demandes: {
    titre: 'طلبات الرسائل',
    aucune: 'لا توجد طلبات',
    aucuneAide: 'ستصل هنا الرسائل الأولى من أعضاء لا تعرفهم بعد.',
  },
  liste: {
    supprimerQ: 'حذف هذه المحادثة؟',
    nouveauGroupe: 'مجموعة جديدة',
    demandesMessage: 'طلبات الرسائل',
    ajouterAmis: 'إضافة أصدقاء',
    reactiverSon: 'إلغاء الكتم',
    sourdine: 'كتم',
    signaler: 'الإبلاغ عن المحادثة',
    supprimer: 'حذف المحادثة',
    vide: 'لا رسائل بعد',
    videAide: 'راسل أحدًا من ملفه، أو انضم إلى خرجة لتتعرّف على الناس.',
    rechercher: 'ابحث في المحادثات…',
    discussions: 'المحادثات',
    messages: 'الرسائل',
    comptes: 'الحسابات',
    envoyerUnMessage: 'أرسل رسالة',
    toiDeuxPoints: 'أنت: ',
    enSourdine: 'مكتومة',
    plusAmis: 'لم تعودا صديقين',
    appelManque: 'مكالمة فائتة',
    appel: 'مكالمة',
    premier: 'أرسل أول رسالة!',
    quitterQ: (nom: string) => `مغادرة ${nom}؟`,
    demandesMessageEnAttente: (n: number) => `طلبات الرسائل · ${n} بالانتظار`,
    demandesAmiEnAttente: (n: number) => `طلبات الصداقة · ${n} بالانتظار`,
    laisserEtPartirQ: (groupe: string, nom: string) => `ترك ${groupe} لـ ${nom} والمغادرة؟`,
    aucuneDiscussion: (recherche: string) => `لا توجد محادثة تطابق «${recherche}».`,
    auteur: (nom: string) => `${nom}: `,
    nonLus: 'رسائل جديدة',
    systeme: {
      quitte: (nom: string) => `غادر ${nom} المجموعة`,
      retire: (nom: string) => `أُزيل ${nom} من المجموعة`,
      rejoint: (nom: string) => `انضم ${nom} إلى المجموعة`,
    },
  },
  nouveauGroupe: {
    impossible: 'تعذّر الإنشاء الآن.',
    titre: 'مجموعة جديدة',
    creer: 'إنشاء المجموعة',
    choisirPhoto: 'اختيار صورة للمجموعة',
    nom: 'اسم المجموعة',
    nomExemple: 'نزهات',
    description: 'الوصف',
    descriptionExemple: 'نلتقي في الحديقة عندما يكون الطقس جميلًا',
    chercher: 'ابحث عن أي اسم مستخدم…',
    selectionnes: (n: number) => `${n} محدّد`,
  },
  annuaire: {
    rechercher: 'ابحث عن عضو',
    vide: 'لا أحد غيرك حاليًا',
    videAide: 'سيظهر أعضاء هذا الخادم هنا فور حصولهم على الوصول.',
    aucun: (recherche: string) => `لا يوجد عضو يطابق «${recherche}»`,
    ecrireA: (nom: string) => `راسل ${nom}`,
    formation: {
      aide: 'ستظهر في قسمه من الدليل.',
      actuelle: 'برنامجك',
    },
    sansFormation: 'برنامج غير محدد',
    voir: (nom: string) => `عرض الأعضاء: ${nom}`,
    videFormation: 'لا أحد في هذا البرنامج حاليًا',
    accueil: {
      etudiants: 'الطلاب',
      etudiantsAide: 'كل الطلاب، مرتّبين حسب التكوين',
      associations: 'الجمعيات',
      associationsAide: 'منشوراتها وفعالياتها وكيفية الانضمام إليها',
    },
    maFormation: {
      bouton: 'تكويني',
      choisir: 'تحديد تكويني',
      aucune: 'عدم التحديد',
      enregistree: 'تم حفظ التكوين',
      impossible: 'تعذّر حفظ تكوينك. حاول مرة أخرى.',
    },
    associations: {
      titre: 'الجمعيات',
      categories: { bde: 'مكاتب الطلاب', citoyennes: 'مدنية', creatives: 'إبداعية', culturelles: 'ثقافية', humanitaires: 'إنسانية', conviviales: 'ترفيهية', internationales: 'دولية', professionnelles: 'مهنية', sportives: 'رياضية ونوادٍ' },
      vide: 'لا توجد جمعيات حاليًا',
      rechercher: 'ابحث عن جمعية',
      aucune: (recherche: string) => `لا توجد جمعية تطابق «${recherche}»`,
      membres: (n: number) => `${n} ${n > 1 ? 'أعضاء' : 'عضو'}`,
      chef: 'المسؤول',
      membre: 'عضو',
      enAttente: 'تم إرسال الطلب',
      rejoindre: 'طلب الانضمام',
      annulerDemande: 'إلغاء طلبي',
      quitter: 'مغادرة الجمعية',
      quitterQ: (nom: string) => `مغادرة ${nom}؟`,
      demandeEnvoyee: 'تم إرسال الطلب إلى المسؤول',
      fil: 'المنشورات',
      evenements: 'الفعاليات',
      lesMembres: 'الأعضاء',
      ecrire: 'النشر في الصفحة',
      creerEvenement: 'إنشاء فعالية',
      filVide: 'لا توجد منشورات بعد',
      evenementsVide: 'لا توجد فعاليات قادمة',
      demandes: (n: number) => `طلبات الانضمام (${n})`,
      accepter: (nom: string) => `قبول ${nom}`,
      refuser: (nom: string) => `رفض ${nom}`,
      retirer: (nom: string) => `إزالة ${nom} من الجمعية`,
      retirerQ: (nom: string) => `إزالة ${nom} من الجمعية؟`,
      sansChef: 'لا يوجد بعد مسؤول لهذه الجمعية لقبول الطلبات.',
      reserveMembres: 'يمكن للجميع قراءة منشوراتها وفعالياتها، والنشر لأعضائها فقط.',
      groupe: 'مجموعة الجمعية',
      groupePasPret: 'المجموعة قيد الإعداد، حاول مجددًا بعد لحظة.',
      introuvable: 'الجمعية غير موجودة',
      impossible: 'تعذّر إتمام العملية. حاول مرة أخرى.',
      dansLeFil: (nom: string) => `في صفحة ${nom}`,
      pourLAsso: (nom: string) => `فعالية ${nom}`,
      voir: (nom: string) => `عرض جمعية ${nom}`,
    },
    filtres: {
      titre: 'عوامل التصفية',
      filtrer: 'تصفية الأعضاء',
      actifs: 'التصفية مفعّلة',
      formation: 'البرنامج',
      langues: 'اللغات',
      effacer: 'مسح الكل',
      fermer: 'عرض الأعضاء',
      aucun: 'لا يوجد عضو يطابق هذه التصفية',
    },
  },
};
